import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../models/user';
import {Farmer} from '../models/farmer';
import {AnalyticsModel} from '../models/analytics-model';
import {NavigatorUtils} from '../utils/navigator.utils';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class SpiPdfMakeService {

  constructor(private http: HttpClient) {
  }

  loadConfig(filename: string) {
    const url = `assets/templatePDFMake/` + filename;
    return this.http.get<any>(url);
  }

}

/*

function(currentPage, pageCount) {
          return { columns: [
              {
                text: currentPage.toString() + '/' + pageCount,
                color : "#555555",
                margin: [ 20, 15, 10, 20 ],
                style: 'small',
              },
              {
                text: 'by spisoft',
                color : "#555555",
                margin: [ 20, 15, 10, 20 ],
                alignment: 'right',
                style: 'small'
              }
            ]};
        }

 */
